const ITEMS = [
  "Consórcio de imóveis",
  "Consórcio de veículos",
  "Sem juros de financiamento",
  "Carta de crédito",
  "Lance inteligente",
  "Planejamento com propósito",
];

function Row({ ariaHidden }) {
  return (
    <div aria-hidden={ariaHidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-lg font-bold uppercase tracking-wide sm:text-xl">
            {item}
          </span>
          <span className="h-2 w-2 rounded-full bg-brand-300" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section className="overflow-hidden border-y border-brand-900 bg-brand-800 py-5" data-testid="brand-marquee">
      <div className="flex w-max animate-marquee text-white">
        <Row />
        <Row ariaHidden />
      </div>
    </section>
  );
}
